import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import device from '../helpers/device'
import refs from '../helpers/refs'
import smoothScroll from '../helpers/smoothScroll'
import site from '../helpers/site'

gsap.registerPlugin(ScrollTrigger)

class CHowItWorks {
  constructor (el) {
    this.site = site()
    this.component = el
    this.$refs = refs(this.component)
    this.vid = this.$refs.howItWorksVideo
    this.scrollTo = smoothScroll
    this.currentStep = 0
    this.lastSection = 3
    // Gravity, Masterbuilt only
    if (this.site === 'masterbuilt') {
      this.timestamps = {
        0: 0, // Video not playing
        1: 0, // Charcoal being poured
        2: 6.48, // Charcoal burning
        3: 11.7, // Digital temperature display
        4: 24.9 // End of video
      }
    } else {
      // Konnected, Kamado Joe only
      this.timestamps = {
        0: 0, // Video not playing
        1: 0, // AFS lighting up
        2: 5.51, // Kontrol Board
        3: 17.75, // Kontrol Fan
        4: 24 // End of video
      }
    }

    this.init()
  }

  init () {
    // [Left side] Step-by-step copy
    this.component.querySelectorAll('.m-how-it-works-card').forEach((panel, i) => {
      const copyTimeline = gsap.timeline({
        scrollTrigger: {
          start: device.isMobile() ? 'top top+=110px' : '+=200 60%',
          end: i === this.lastSection ? 'bottom bottom' : '+=200 -20%',
          trigger: panel,
          pin: `.m-how-it-works-card--${i} .m-how-it-works-card__content-wrap`,
          pinSpacing: false,
          scrub: true,
          onEnter: () => this.seekVideo(i),
          onEnterBack: () => this.seekVideo(i)
        }
      })

      if (i !== this.lastSection) {
        copyTimeline.to(panel, { opacity: 0, duration: 0.4 }, 0.8) // Fade out
      }
    })

    // [Right side] Video
    gsap.timeline({
      scrollTrigger: {
        start: device.isMobile() ? 'top top+=100px' : '+=300 50%',
        end: 'bottom bottom',
        trigger: '.c-how-it-works__video-container',
        pin: '.c-how-it-works__video-container > .c-how-it-works__video-wrap',
        pinSpacing: false,
        scrub: true
      }
    })

    // 'timeupdate' is triggered at 2fps when video is playing
    this.vid.addEventListener('timeupdate', () => { this.videoLoop() })
  }

  // TODO: Make sure this still works on slow connections
  seekVideo (step) {
    if (this.currentStep !== step) {
      this.currentStep = step
      this.vid.currentTime = this.timestamps[this.currentStep]
      this.vid.play()
    }
  }

  videoLoop () {
    // Check if section of video is complete -> pause the video
    if (this.vid.currentTime >= this.timestamps[this.currentStep + 1]) {
      this.vid.currentTime = this.timestamps[this.currentStep + 1]
      this.vid.pause()
    }
  }
}

// GSAP components bug out if loaded too early
window.addEventListener('load', () => {
  document.querySelectorAll('[data-c-how-it-works]').forEach(el => new CHowItWorks(el))
})
